import Vue from 'vue'
import VueRouter from 'vue-router'


function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: lazyLoad('Home'),
    meta: {
      title: () => 'Oracle AI | A world of powerful AI solutions',
    }
  },
  {
    path: '/helmet', name: 'Helmet', 
    component: lazyLoad('Helmet'),
    meta: {
      title: () => 'Oracle | Helmet Predictor',
    }
  },
  {
    path: '/vest', name: 'Vest', 
    component: lazyLoad('Vest'),
    meta: {
      title: () => 'Oracle | Vest Predictor',
    }
  },
  {
    path: '/facemask', name: 'Facemask', 
    component: lazyLoad('Facemask'),
    meta: {
      title: () => 'Oracle | Facemask Predictor',
    }
  },
  {
    path: '/about', name: 'About', 
    component: lazyLoad('About'),
    meta: {
      title: () => 'Oracle | About Oracle',
      guest: true
    }
  },
  {
    path: '/login', name: 'login', 
    component: lazyLoad('Login'),
    meta: {
      title: () => 'MoneyPool | Login',
      guest: true
    }
  },
  {
    path: '/signup', name: 'signup', 
    component: lazyLoad('Signup'),
    meta: {
      title: () => 'MoneyPool | Signup',
      guest: true
    }
  },
  {
    path: '/forgot-password/verify/:reset_token', name: 'new-password', 
    component: lazyLoad('NewPassword'),
    meta: {
      title: () => 'MoneyPool | New Password',
      guest: true
    }
  },
  {
    path: '/reset-password', name: 'reset-password', 
    component: lazyLoad('ResetPassword'),
    meta: {
      title: () => 'MoneyPool | Reset Password',
      guest: true
    }
  },
  {
    path: '/thank-you', name: 'thank-you', 
    component: lazyLoad('ThankYou'),
    meta: {
      title: () => 'MoneyPool | ThankYou',
      guest: true
    }
  },
  { 
    path: '/pool/accept-invite/:pool_id/:invite_code', name: 'accept-invite', 
    component: lazyLoad('AcceptInvite'), 
    meta: { 
      title: () => 'MoneyPool | Accept Invite',
      // guest: true
    }
  },
  { 
    path: '/pool/share/:pool_id', name: 'share-pool', 
    component: lazyLoad('PoolShare'), 
    meta: { 
      title: () => 'MoneyPool | Pool',
    }
  },
  { 
    path: '/pool/confirm-email/:pool_id', name: 'confirm-email', 
    component: lazyLoad('ConfirmEmailAddress'), 
    meta: { 
      title: () => 'MoneyPool | Confirm Email',
    }
  },
  { 
    path: '/make-contribution/:pool_id/:invite_id', name: 'make-contribution', 
    component: lazyLoad('MakeContribution'), 
    meta: { 
      title: () => 'MoneyPool | Make Contribution',
      requiresAuth: true
    }
  },
  {
    path: '/payment-success', name: 'payment-success', 
    component: lazyLoad('PaymentSuccess'),
    meta: {
      title: () => 'MoneyPool | Payment Success',
      requiresAuth: true
    }
  },
  // {
  //   path: '/dashboard', 
  //   component: lazyLoad('Dashboard'),
  //   meta: {
  //     requiresAuth: true
  //   },
  //   children: [
  //     { 
  //       path: '', name: 'dashboard', 
  //       component: lazyLoad('IndexPage'), 
  //       meta: { 
  //         title: () => 'MoneyPool | Dashboard'
  //       }
  //     },
  //     {
  //       path:'/mypools', name: 'mypools', 
  //       component: lazyLoad('MyPools'),
  //       meta: {
  //         title: () => 'MoneyPool | Mypools',
  //         requiresAuth: true
  //       },
  //     },
  //     {
  //       path:'/mypools/:pool_id', name: 'viewpool', 
  //       component: lazyLoad('ViewPool'),
  //       meta: {
  //         title: () => 'MoneyPool | View',
  //         requiresAuth: true
  //       },

  //     },
  //     {
  //       path:'/create', name: 'create', 
  //       component: lazyLoad('CreatePool'),
  //       meta: {
  //         title: () => 'MoneyPool | Create',
  //         requiresAuth: true
  //       }
  //     },
  //     {
  //       path:'/contacts', name: 'contacts', 
  //       component: lazyLoad('Contacts'),
  //       meta: {
  //         title: () => 'MoneyPool | Contact',
  //         requiresAuth: true
  //       }
  //     },
  //     {
  //       path:'/myaccount', name: 'myaccount', 
  //       component: lazyLoad('MyAccount'),
  //       meta: {
  //         title: () => 'MoneyPool | My Account',
  //         requiresAuth: true
  //       }
  //     },
  //     {
  //       path: '/initiate-payout/:pool_id', name: 'initiate-payout', 
  //       component: lazyLoad('InitiatePayout'),
  //       meta: {
  //         title: () => 'MoneyPool | Initiate Payout',
  //         requiresAuth: true
  //       }
  //     },
  //     {
  //       path:'/payout-votes/:pool_id', name: 'payout-votes', 
  //       component: lazyLoad('PayoutVotes'),
  //       meta: {
  //         title: () => 'MoneyPool | PayoutVotes',
  //         requiresAuth: true
  //       },
  //     },
  //     {
  //       path: '/payouts', name: 'payouts',
  //       component: lazyLoad('Payouts'),
  //       meta: {
  //         title: () => 'MoneyPool | Payouts',
  //         requiresAuth: true
  //       }
  //     }
  //   ]
  // },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
      // if user is not authenticated
      if (localStorage.getItem('access_token') == null) {
          next({
              path: '/login',
              params: { nextUrl: to.fullPath }
          })
      } else {
        // if user is authenticated
          next();
      }
  } else if (to.matched.some(record => record.meta.guest)) {
      if (localStorage.getItem('access_token') == null){
        next()
      }
      else {
        next({ name: 'dashboard' })
      }
  } else {
      next() 
  }
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title();
  });

});

export default router
